export class WebhookV1StandardPayloadBackupJobSkipped {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1StandardPayloadBackupJobSkippedTypeEnum",
            "format": ""
        },
        {
            "name": "arguments",
            "baseName": "arguments",
            "type": "WebhookV1StandardPayloadBackupJobSkippedArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadBackupJobSkipped.attributeTypeMap;
    }
    constructor() {
    }
}
export var WebhookV1StandardPayloadBackupJobSkippedTypeEnum;
(function (WebhookV1StandardPayloadBackupJobSkippedTypeEnum) {
    WebhookV1StandardPayloadBackupJobSkippedTypeEnum["BackupJobSkipped"] = "BACKUP_JOB_SKIPPED";
})(WebhookV1StandardPayloadBackupJobSkippedTypeEnum || (WebhookV1StandardPayloadBackupJobSkippedTypeEnum = {}));
